import { BreakpointObserver } from '@angular/cdk/layout';

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { MaterialModule } from '../../material.module';
import { ShareMenuDialogComponent } from '../share-menu-dialog/share-menu-dialog.component';

@Component({
  selector: 'app-share-button',
  templateUrl: './share-button.component.html',
  styleUrls: ['./share-button.component.css'],
  standalone: true,
  imports: [MaterialModule, TranslateModule],
})
export class ShareButtonComponent implements OnInit, OnDestroy {
  private routeSub: Subscription;
  @Input() course;
  @Input() blogID;
  @Input() contentID;
  courseID;
  sectionID;
  lectureID;

  constructor(
    private appService: AppService,
    private dialog: MatDialog,
    private bottomSheet: MatBottomSheet,
    private aRoute: ActivatedRoute,
    private breakpointObserver: BreakpointObserver,
    private translate: TranslateService
  ) {
    this.routeSub = this.aRoute.params.subscribe((params) => {
      if (params.course) {
        this.courseID = params.course;
        this.sectionID = params.section;
        this.lectureID = params.lecture;
      }
    });
  }

  ngOnInit() {
    // this.openShareMenu()
  }

  ngOnDestroy() {
    this.routeSub.unsubscribe();
  }

  openShareMenu() {
    const isSmallScreen = this.breakpointObserver.isMatched('(max-width: 599px)');
    if (isSmallScreen) {
      this.bottomSheet.open(ShareMenuDialogComponent, {
        data: {
          courseID: this.courseID,
          sectionID: this.sectionID,
          lectureID: this.lectureID,
          blogID: this.blogID,
        },
      });
    } else {
      this.dialog.open(ShareMenuDialogComponent, {
        width: '500px',
        maxHeight: '80vh',
        data: {
          courseID: this.courseID,
          sectionID: this.sectionID,
          lectureID: this.lectureID,
          blogID: this.blogID,
        },
      });
    }
  }
}
